module.exports = __webpack_public_path__ + "c53426859f0b47de3a2d7ccf9324e1f2.svg";